import { Price } from '@kanda-libs/ks-design-library';
import useJobItemTotal from './useItemTotal';

export interface ItemTotalProps {
  index: number;
  arrayName: string;
}

const ItemTotal: React.FunctionComponent<ItemTotalProps> = function ({
  index,
  arrayName,
}) {
  const { vatAmount, totalAmount } = useJobItemTotal(index, arrayName);
  return (
    <div className="grid grid-cols-2 ml-auto gap-x-3 gap-y-1 text-right">
      <p className="text-18-22-em text-neutral-700 my-auto">VAT Total:</p>
      <Price amount={vatAmount} className="ml-auto" />
      <p className="text-18-22-em text-neutral-700 my-auto">Job Total:</p>
      <Price amount={totalAmount} className="ml-auto" />
    </div>
  );
};

export default ItemTotal;
